<template>
	<div id="pageTable">
		<v-container grid-list-xl fluid>
			<v-layout row wrap >
				<v-flex sm12>
					<div class="col-md-12" style="float: right;">
						<v-dialog v-model="modalempresa.dialog" persistent max-width="500px">
							<v-btn color="primary" dark slot="activator">Nova Empresa</v-btn>
							<v-card>
								<v-card-title>
									<span class="headline">Cadastro de Empresa</span>
								</v-card-title>
								<v-divider></v-divider>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<v-flex xs12>
												<v-text-field
												label="Nome"
												v-model="empresa.name"
												:rules="[rules.required]"
												required></v-text-field>
											</v-flex>            
											<v-flex xs12>
												<v-text-field
												label="CNPJ"
												v-model="empresa.cnpj"
												:rules="[rules.required]"
												v-mask="['###.###.###-##', '##.###.###/####-##']"
												required></v-text-field>
											</v-flex>              
											<v-flex xs12>
												<v-text-field
												label="E-mail"
												v-model="empresa.email"
												:rules="[rules.required, rules.email]"
												required></v-text-field>
											</v-flex>                  
											<v-flex xs12>
												<v-text-field
												label="Telefone"
												:rules="[rules.required]"           
												v-model="empresa.phone"
												v-mask="['(##) ####-####', '(##) #####-####']"
												required></v-text-field>  
											</v-flex>
											<v-flex xs12>
												<v-text-field name="password" label="Senha painel Cliente" id="password" type="password" v-model="empresa.password_visible"
												:rules="[rules.required]"
												>
											</v-text-field>
										</v-flex>
									</v-layout>
								</v-container>
							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="blue darken-1" flat @click.native="modalempresa.dialog = false">Fechar</v-btn>
								<v-btn color="blue darken-1" flat @click="creatEmpresa()">Salvar</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</div>
			</v-flex>

			<!-- tabela das empresas -->	
			<v-flex lg12>
				<vue-good-table
				:columns="columns"
				:rows="companies"
				@on-row-click="onCellClick"
				@on-cell-click="onCellClick"
				:pagination-options="{
				enabled: true,
				nextLabel: 'next',
				prevLabel: 'prev',
				rowsPerPageLabel: 'Registros por página',
				ofLabel: 'of',
				allLabel: 'Todos',
			}"
			styleClass="vgt-table bordered vgt-table condensed"
			/>  
		</vue-good-table>
	</v-flex>

	<!-- div modal funcionarios da empesa -->
	<v-flex>
		<v-dialog v-model="modalfuncempresa.dialog" persistent max-width="100%">
			<v-card>
				<v-card-title>
					<span class="headline">Funcionários da Empresa:</span>
					<strong><input type="text" v-model="dados_companies.name" class="form-control" style="font-size: 25px!important; margin-left: 10px"></strong>
				</v-card-title>
				<v-flex style="float: right;">
					<button type="button" class="v-btn v-btn--small theme--dark primary" style="position: relative;" v-on:click="divFunc = true" v-if="!divFunc && !divEditFunc"><div class="v-btn__content">Novo Funcionário</div>
					</button>				
					<button type="button" class="v-btn v-btn--small theme--dark primary" style="position: relative;" @click="creatEmployed()" v-if="divFunc && !divEditFunc"><div class="v-btn__content">Gravar</div>
					</button>							
					<button type="button" class="v-btn v-btn--small theme--dark primary" style="position: relative;" v-on:click="divFunc = false"  v-if="divFunc && !divEditFunc"><div class="v-btn__content">Cancelar</div>
					</button>						
					<button type="button" class="v-btn v-btn--small theme--dark primary" style="position: relative;" @click="updateEmployed()" v-if="divEditFunc && !divFunc"><div class="v-btn__content">Alterar</div>		
					</button>						
					<button type="button" class="v-btn v-btn--small theme--dark primary" style="position: relative;" @click="clickCancelEdit()" v-if="divEditFunc && !divFunc"><div class="v-btn__content">Cancelar</div>		
					</button>
				</v-flex>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex lg12 v-if="!divFunc && !divEditFunc">
							<v-container grid-list-md>
								<vue-good-table
								:columns="columnsemployees"
								:rows="employees"
								@on-row-click="verEmployee"
								:pagination-options="{
								enabled: true,
								perPage: 5,
							}"
							styleClass="vgt-table bordered condensed"
							/>  
						</vue-good-table>
					</v-container>
				</v-flex>												
				<v-flex lg6 v-if="divFunc">
					<v-container grid-list-md>
						<vue-good-table
						:columns="columnsemployees"
						:rows="employees"
						@on-row-click="verEmployee"
						:pagination-options="{
						enabled: true,
						perPage: 5,
					}"
					styleClass="vgt-table bordered condensed"
					/>  
				</vue-good-table>
			</v-container>
		</v-flex>					
		<v-flex lg6 v-if="divEditFunc">
			<v-container grid-list-md>
				<vue-good-table
				:columns="columnsemployees"
				:rows="employees"
				@on-row-click="verEmployee"
				:pagination-options="{
				enabled: true,
				perPage: 5,
			}"
			styleClass="vgt-table bordered condensed"
			/>  
		</vue-good-table>
	</v-container>
</v-flex>
<v-flex lg6 v-if="divFunc">
	<v-layout wrap>
		<v-flex xs10>
			<v-text-field
			label="Nome"
			v-model="funcionario.name"
			:rules="[rules.required]"  
			></v-text-field>
		</v-flex>            
		<v-flex xs6>
			<v-text-field
			label="CPF"
			v-mask="['###.###.###-##']"
			:rules="[rules]"  
			v-model="funcionario.cpf"
			></v-text-field>
		</v-flex>
		<v-flex xs6>
			<v-text-field
			label="RG"
			v-model="funcionario.rg"
			></v-text-field>
		</v-flex>
		<v-flex xs6>
			<v-text-field
			label="Cargo"
			v-model="funcionario.office"
			></v-text-field>
		</v-flex>                                                             
		<v-flex xs3>
			<v-text-field
			label="CTPS"
			v-model="funcionario.ctps"
			></v-text-field>
		</v-flex>                         
		<v-flex xs3>
			<v-text-field
			label="PIS"
			v-model="funcionario.pis"
			></v-text-field>
		</v-flex> 			
		<v-flex xs4>
			<v-menu
			class="pr-2"
			ref="startDate"
			lazy
			:close-on-content-click="false"
			v-model="startDateMenu"
			transition="scale-transition"
			offset-y
			full-width
			:nudge-bottom="-22"
			max-width="290px"
			:return-value.sync="startDate"
			>
			<v-text-field
			slot="activator"
			label="Data de nascimento"
			v-model="dateFormatNascimento"
			@blur="dateNasicmento = parseDate(dateNasicmento)"
			prepend-icon="event"
			readonly
			></v-text-field>
			<v-date-picker v-model="dateNasicmento" locale="pt-br" @input="$refs.startDate.save(funcionario.born_date)" >
			</v-date-picker>
		</v-menu>
	</v-flex>                        
	<v-flex xs4>
		<v-menu
		class="pr-2"
		ref="endDate"
		lazy
		:close-on-content-click="false"
		v-model="endDateMenu"
		transition="scale-transition"
		offset-y
		full-width
		:nudge-bottom="-22"
		max-width="290px"
		:return-value.sync="endDate"
		>
		<v-text-field
		slot="activator"
		label="Data de Admissão"
		v-model="dateFormatAdmission"
		@blur="dateAdmission = parseDate(dateAdmission)"
		prepend-icon="event"
		readonly
		></v-text-field>
		<v-date-picker v-model="dateAdmission" locale="pt-br" @input="$refs.endDate.save(funcionario.admission)" >
		</v-date-picker>
	</v-menu>
</v-flex> 
<v-flex xs4>
	<input type="radio" id="one" value="M" v-model="funcionario.gender">
	<label for="one">Masculino</label>
	<br>
	<input type="radio" id="two" value="F" v-model="funcionario.gender">
	<label for="two">Femenino</label>
</v-flex>                                
</v-layout>
</v-flex>				
<v-flex lg6 v-if="divEditFunc">
	<v-layout wrap>
		<v-flex xs10>
			<v-text-field
			label="Nome"
			v-model="dados_employees.name"
			:rules="[rules.required]"  
			></v-text-field>
		</v-flex>            
		<v-flex xs6>
			<v-text-field
			label="CPF"
			v-mask="['###.###.###-##']"
			:rules="[rules]"  
			v-model="dados_employees.cpf"
			></v-text-field>
		</v-flex>
		<v-flex xs6>
			<v-text-field
			label="RG"
			v-model="dados_employees.rg"
			></v-text-field>
		</v-flex>
		<v-flex xs6>
			<v-text-field
			label="Cargo"
			v-model="dados_employees.office"
			></v-text-field>
		</v-flex>                                                             
		<v-flex xs3>
			<v-text-field
			label="CTPS"
			v-model="dados_employees.ctps"
			></v-text-field>
		</v-flex>                         
		<v-flex xs3>
			<v-text-field
			label="PIS"
			v-model="dados_employees.pis"
			></v-text-field>
		</v-flex> 			
		<v-flex xs4>
			<v-menu
			class="pr-2"
			ref="startDateEdit"
			lazy
			:close-on-content-click="false"
			v-model="startEditDateMenuEdit"
			transition="scale-transition"
			offset-y
			full-width
			:nudge-bottom="-22"
			max-width="290px"
			:return-value.sync="startDateEdit"
			>
			<v-text-field
			slot="activator"
			label="Data de nascimento"
			v-model="dateFormatNascimento"
			@blur="dateNasicmento = parseDate(dateNasicmento)"
			prepend-icon="event"
			readonly
			></v-text-field>
			<v-date-picker v-model="dateNasicmento" locale="pt-br" @input="$refs.startDateEdit.save(dados_employees.born_date)" >
			</v-date-picker>
		</v-menu>
	</v-flex>                        
	<v-flex xs4>
		<v-menu
		class="pr-2"
		ref="endDateEdit"
		lazy
		:close-on-content-click="false"
		v-model="endEditDateMenuEdit"
		transition="scale-transition"
		offset-y
		full-width
		:nudge-bottom="-22"
		max-width="290px"
		:return-value.sync="endDateEdit"
		>
		<v-text-field
		slot="activator"
		label="Data de Admissão"
		v-model="dateFormatAdmission"
		@blur="dateAdmission = parseDate(dateAdmission)"
		prepend-icon="event"
		readonly
		></v-text-field>
		<v-date-picker v-model="dateAdmission" locale="pt-br" @input="$refs.endDateEdit.save(dados_employees.admission)" >
		</v-date-picker>
	</v-menu>
</v-flex> 
<v-flex xs4>
	<input type="radio" id="one" value="M" v-model="dados_employees.gender">
	<label for="one">Masculino</label>
	<br>
	<input type="radio" id="two" value="F" v-model="dados_employees.gender">
	<label for="two">Femenino</label>
</v-flex>                                
</v-layout>
</v-flex>	
</v-layout>
</v-container>
<v-card-actions>
	<v-spacer></v-spacer>
	<v-btn color="blue darken-1" flat @click="fecharModalFuncEmpresa()">Fechar</v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</v-flex> 


<!-- modal editando empresa -->
<v-flex>
	<v-dialog v-model="modaleditempresa.dialog" persistent max-width="500px">
		<v-card>
			<v-card-title>
				<span class="headline">Editando Empresa</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12>
							<v-text-field
							label="Nome"
							v-model="dados_companies.name"
							:rules="[rules.required]"
							required></v-text-field>
						</v-flex>            
						<v-flex xs6>
							<v-text-field
							label="CNPJ"
							v-model="dados_companies.cnpj"
							:rules="[rules.required]"
							v-mask="['###.###.###-##', '##.###.###/####-##']"
							required></v-text-field>
						</v-flex>
						<v-flex xs6>	
							<v-text-field
							label="Telefone"
							v-mask="['(##) ####-####', '(##) #####-####']"
							:rules="[rules.required]"           
							v-model="dados_companies.phone"
							required>
						</v-text-field>  
					</v-flex>	              
					<v-flex xs12>
						<v-text-field
						label="E-mail"
						v-model="dados_companies.email"
						:rules="[rules.required, rules.email]"
						required></v-text-field>
					</v-flex>                  					
					<v-flex xs12 v-if="dados_companies.password_visible">
						<v-text-field
						label="Senha cadastrada para acesso ai painel"
						:rules="[rules.required]"           
						v-model="dados_companies.password_visible"
						required>
					</v-text-field>  
				</v-flex>					
				<v-flex xs12 v-else>
					<v-text-field
					label="Cadastre uma senha para acesso ai painel"
					:rules="[rules.required]"           
					v-model="dados_companies.password_visible"
					required>
				</v-text-field>  
			</v-flex>
			<v-switch
			label="Ativo"
			v-model="dados_companies.active"
			></v-switch> 
		</v-layout>
	</v-container>
</v-card-text>
<v-card-actions>
	<v-spacer></v-spacer>
	<v-btn color="blue darken-1" flat @click="fecharModalEditandoEmpresa()">Fechar</v-btn>
	<v-btn color="blue darken-1" flat @click="updateEmpresa()">Salvar</v-btn>
</v-card-actions>
</v-card>
</v-dialog>
</v-flex> 


<!-- modal e-mail -->
<v-flex>
	<v-dialog v-model="modalemail.dialog" persistent max-width="500px">
		<v-card>
			<v-card-title>
				<span class="headline">Editando Empresa</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12>
							<v-text-field
							label="Nome"
							v-model="dados_companies.name"
							:rules="[rules.required]"
							required></v-text-field>
						</v-flex>            
						<v-flex xs12>
							<v-text-field
							label="CNPJ"
							v-model="dados_companies.cnpj"
							:rules="[rules.required]"
							v-mask="['###.###.###-##', '##.###.###/####-##']"
							required></v-text-field>
						</v-flex>              
						<v-flex xs12>
							<v-text-field
							label="E-mail"
							v-model="dados_companies.email"
							:rules="[rules.required, rules.email]"
							required></v-text-field>
						</v-flex>                  
						<v-flex xs12>
							<v-text-field
							label="Telefone"
							v-mask="['(##) ####-####', '(##) #####-####']"
							:rules="[rules.required]"           
							v-model="dados_companies.phone"
							required>
						</v-text-field>  
					</v-flex>
					<v-switch
					label="Ativo"
					v-model="dados_companies.active"
					></v-switch> 
				</v-layout>
			</v-container>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="blue darken-1" flat @click.native="modalemail.dialog = false">Fechar</v-btn>
			<v-btn color="blue darken-1" flat @click="">Enviar</v-btn>
		</v-card-actions>
	</v-card>
</v-dialog>
</v-flex> 



</v-layout>
</v-container>
</div>
</template>

<script>
import {http, httpLogin} from '../../backend/vue-axios/axios';
import swal from 'sweetalert';
import { mapGetters } from 'vuex';


export default {
	data () {
		return {
			divFunc: false,
			divEditFunc: false,
			search: '',
			companies: [],
			dados_companies:[],
			dados_employees:[],
			employees:[],
			id_user:'',
			columns: [
			{
				label: 'Nome',
				field: 'name',
				filterOptions: {
					enabled: true,
					placeholder: 'Informe o nome da empresa', 
					filterDropdownItems: [], 
					filterFn: this.columnFilterFn,
				},
				 tdClass: 'text-center',
			},
			{
				label: 'CNPJ',
				field: 'cnpj',
				filterOptions: {
		          enabled: true, // enable filter for this column
		          placeholder: 'Informe o cnpj da empresa', // placeholder for filter input
		          filterDropdownItems: [], // dropdown (with selected values) instead of text input
		          filterFn: this.columnFilterFn, //custom filter function that
		      },
		  },		
		  {
		  	label: 'E-mail',
		  	field: 'email',
		  	filterOptions: {
		          enabled: true, // enable filter for this column
		          placeholder: 'Informe o e-mail da empresa', // placeholder for filter input
		          filterDropdownItems: [], // dropdown (with selected values) instead of text input
		          filterFn: this.columnFilterFn, //custom filter function that
		      },
		  },		 
		  {
		  	label: 'Telefone',
		  	field: 'phone',
		  },
		  {
		  	label: 'Edição',
		  	field: 'btnedit',
		  	html: true,
		  },		  
		  {
		  	label: 'Func',
		  	field: 'btnempregados',
		  	html: true,
		  },		  
		  {
		  	label: 'Mail',
		  	field: 'btnemail',
		  	html: true,
		  }
		  ],

		  columnsemployees: [
		  {
		  	label: 'Nome',
		  	field: 'name',
		  	filterOptions: {
		        enabled: true, // enable filter for this column
		        placeholder: 'Informe o nome do funcionário', // placeholder for filter input
		        filterDropdownItems: [], // dropdown (with selected values) instead of text input
		        filterFn: this.columnFilterFn, //custom filter function that
		    },	
		},
		{
			label: 'CPF',
			field: 'cpf',
		},		   
		{
			label: 'Cargo',
			field: 'office',
		}
		],
		empresa: {
			name: '',
			cnpj: '',
			ativo: '', 
			email:'',
			password_visible: '',
			user_id: '',
			phone: '',
		},
		funcionario: {
			name:'',
			cpf:'',
			office:'',
			gender: '',
			pis: '',
			ctps: '',
			rg: '',
			admission: '',
			born_date: '',
		},
		modalempresa: {
			dialog: false
		},			
		modaleditempresa: {
			dialog: false
		},			
		modalfuncempresa: {
			dialog: false
		},		
		modalempregado: {
			dialog: false
		},		
		modalempregadoedit: {
			dialog: false
		},		
		modalemail: {
			dialog: false
		},
		startDateMenu: false,
		startEditDateMenuEdit: false,
		endDateMenu: false,
		endEditDateMenuEdit: false,
		startDate: null,
		endDate: null,
		startDateEdit: null,
		endDateEdit: null,
		dateFormatNascimento: null,
		dateFormatAdmission: null,
		dateAdmission: null,
		dateNasicmento: null,

		rules: {
			required: (value) => !!value || 'Campo Obrigtório.',
			email: (value) => {
				const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				return pattern.test(value) || 'E-mail inválido.';
			} 
		},
	};
},

watch: {
	dateNasicmento (val) {
		this.dateFormatNascimento = this.formatDate(this.dateNasicmento)
	},
	dateAdmission (val) {
		this.dateFormatAdmission = this.formatDate(this.dateAdmission)
	}
},

computed: {
	...mapGetters({ currentUser: 'currentUser' }),

	computedDateFormatted () {
		return this.formatDate(this.date)
	}
},
mounted () {
	this.buscaEmpresa();
}, 
methods: {

	formatDate (date) {
		if (!date) return null

			const [year, month, day] = date.split('-')
		return `${day}/${month}/${year}`
	},
	parseDate (date) {
		if (!date) return null

			const [month, day, year] = date.split('/')
		return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
	},

	handleClick (e) {
		e.preventDefault();
	},

	onCellClick(params)
	{
		if(params.column.field == 'btnempregados')
		{
			this.clickFuncEmpresa(params)
		}else if(params.column.field == 'btnemail')
		{
			this.clickEmail(params)
		}else{
			this.clickTd(params)
		}	
		
	},

	creatEmpresa() {
		
		//grava user
		http.post('users', {
			email: this.empresa.email,
			password_visible: this.empresa.password_visible,
			password: this.empresa.password_visible,
			password_confirmation: this.empresa.password_visible,
			name: this.empresa.name,
			role: 0,
		})
		.then(response => {
			//console.log(response.data)
			//this.id_user.push(response.data.id)
			this.id_user = response.data.id
			swal({
				title: "Empresa!",
				text: "cadastrada com sucesso!",
				icon: "success",
				timer: 1000,
				button: false

			});
			this.criandEmpresa()
		})
		.catch(error => {
			console.log(error)
		});
	},

	criandEmpresa(){
		
		//grava empresa
		http.post('companies', {
			name: this.empresa.name,
			cnpj: this.empresa.cnpj,
			email: this.empresa.email,
			user_id: this.id_user,
			phone: this.empresa.phone,
		})
		.then(response => {
			this.modalempresa.dialog = false;
			this.resetCreatComp();
			this.buscaEmpresa();

		})
		.catch(error => {
			console.log(error)
		});
	},


	buscaEmpresa() {

		
		http.get('companies')
		.then(response => {
       // console.log(response.data);
       this.companies = response.data;
       for (var company in this.companies) {
       	this.companies[company].btnedit = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">edit</i></div></button>' 	
       	this.companies[company].btnempregados = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">how_to_reg</i></div></button>',
       	this.companies[company].btnemail = '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--outline v-btn--depressed v-btn--small theme--dark primary--text" style="position: relative;"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons">mail</i></div></button>'
       }

   })
		.catch(error => {
			console.log();			
		});
	},

	updateEmpresa()
	{
		http.put('companies/' + this.dados_companies.id,{
			name: this.dados_companies.name,
			cnpj: this.dados_companies.cnpj,
			email: this.dados_companies.email,
			phone: this.dados_companies.phone,
			active: this.dados_companies.active,
		})
		.then(response => {
			this.buscaEmpresa()
			this.updateUser()
			this.modaleditempresa.dialog = false
			swal({
				title: "Empresa!",
				text: "atualizada com sucesso!",
				icon: "success",
				timer: 1000,
				button: false

			});
			this.dados_companies.push(response.data);			
		})
		.catch(error => {
			console.log(error);
		});
		this.buscaEmpresa();
	},

	updateUser()
	{
		if(this.dados_companies.user_id == null){
			
		//grava user
		http.post('users', {
			name: this.dados_companies.name,
			password_visible: this.dados_companies.password_visible,
			email: this.dados_companies.email,
			password: this.dados_companies.password_visible,
			password_confirmation: this.dados_companies.password_visible,
			role: 1,
		})
		.then(response => {
			this.id_user = response.data.id

			http.put('companies/' + this.dados_companies.id, {
				user_id: this.id_user,
				name: this.dados_companies.name,
				cnpj: this.dados_companies.cnpj,
				email: this.dados_companies.email,
				phone: this.dados_companies.phone,
				active: this.dados_companies.active,
				
			})
			.then(response => {

				this.buscaEmpresa()
				this.modaleditempresa.dialog = false
				swal({
					title: "Empresa!",
					text: "atualizada com sucesso!",
					icon: "success",
					timer: 1000,
					button: false

				});
			})
			.catch(error => {
				console.log(error);
			});

			swal({
				title: "Empresa!",
				text: "cadastrada com sucesso!",
				icon: "success",
				timer: 1000,
				button: false

			});
			this.buscaEmpresa()
		})
		.catch(error => {
			console.log(error)
		});

	}else{
		http.put('users/' + this.dados_companies.user_id , {
			name: this.dados_companies.name,
			password_visible: this.dados_companies.password_visible,
			email: this.dados_companies.email,
			password: this.dados_companies.password_visible,
			password_confirmation: this.dados_companies.password_visible,
		})
		.then(response => {

			this.buscaEmpresa();
			this.modaleditempresa.dialog = false;
			swal({
				title: "Empresa!",
				text: "atualizada com sucesso!",
				icon: "success",
				timer: 1000,
				button: false

			});
			this.dados_companies.push(response.data);
		})
		.catch(error => {
			console.log(error)
		});
	}
},


clickTd(params)
{

	if(params.row.id == null || params.row.id == '')
	{
		swal({
			title: "Não",
			text: "foi possível editar o cadastro!",
			icon: "success",
			timer: 1000,
			button: false

		});
	}  

	this.modaleditempresa.dialog = true;

	if(params.row.user != null){
		let data = {
			id: params.row.id,
			name: params.row.name,
			cnpj: params.row.cnpj,
			email: params.row.email,
			phone: params.row.phone,
			active: params.row.active,
			user_id: params.row.user_id,
			password_visible: params.row.user.password_visible,
		}
		this.dados_companies = data;
	}else{
		let data = {
			id: params.row.id,
			name: params.row.name,
			cnpj: params.row.cnpj,
			email: params.row.email,
			phone: params.row.phone,
			active: params.row.active,
			password_visible: null,
			user_id: null,
		}
		this.dados_companies = data;
	}
},	

clickEmail(params)
{
	if(params.row.id == null || params.row.id == '')
	{
		swal({
			title: "Não",
			text: "foi possível editar o cadastro!",
			icon: "success",
			timer: 1000,
			button: false
		});
	}  
	let data = {
		id: params.row.id,
		name: params.row.name,
		cnpj: params.row.cnpj,
		email: params.row.email,
		phone: params.row.phone,
		active: params.row.active,
	}
	this.dados_companies = data;  

	swal({
		title: "Deseja enivar e-mail com a senha do usuário?",
		text: "Será enviado para o e-mail do cadastro.",
		icon: "warning",
		buttons: true,
		dangerMode: true,
	})
	.then((willDelete) => {
		if(willDelete){

			http.post('',data).then(response => {

			});  
			swal("Registro excluído com sucesso!", {
				icon: "success",
			});
		} else{
		}
	});    
},


clickFuncEmpresa(params)
{
	if(params.row.id == null || params.row.id == '')
	{
		swal({
			title: "Não",
			text: "foi possível editar o cadastro!",
			icon: "success",
			timer: 1000,
			button: false

		});
	}  
	this.buscaEmpregados(params);
	let data = {
		id: params.row.id,
		name: params.row.name,
		cnpj: params.row.cnpj,
		email: params.row.email,
		phone: params.row.phone,
		active: params.row.active,
	}

	this.dados_companies = data;
	this.modalfuncempresa.dialog = true;

},

creatEmployed()
{

	http.post('employees', {
		company_id: this.dados_companies.id,
		name: this.funcionario.name,
		cpf: this.funcionario.cpf,
		office: this.funcionario.office,
		gender: this.funcionario.gender,
		born_date: this.dateNasicmento,
		admission: this.dateAdmission,
		rg: this.funcionario.rg,
		ctps: this.funcionario.ctps,
		pis: this.funcionario.pis
	})
	.then(response => {

		this.employees.push(response.data);
		this.divFunc = false;
		this.resetCreatFunc()
		this.limpadatas()
		
		swal({
			title: "Funcionário!",
			text: "cadastrado com sucesso!",
			icon: "success",
			timer: 1000,
			button: false

		});
	})
	.catch(error => {
		console.log()
	});
},


buscaEmpregados(params)
{
	console.log(params.row.id)
	let id_empresa = params.row.id;
	
	  //pega os funcionarios da empresa
	  http.get('companies/'+ id_empresa + '/employees')
	  .then(response => {
	  	console.log(response.data);
	  	this.employees = response.data;

	  })
	  .catch(error => {
	  	this.errors = response;
	  });
	},

	verEmployee(params)
	{
		if(params.row.id == null || params.row.id == '')
		{
			swal({
				title: "Não",
				text: "foi possível editar o cadastro!",
				icon: "success",
				timer: 1000,
				button: false

			});
		}  
		this.divEditFunc = true;
		this.divFunc = false;
		console.log(params)
		let data = {
			id: params.row.id,
			name: params.row.name,
			cpf: params.row.cpf,
			office: params.row.office,
			gender: params.row.gender,
			pis: params.row.pis,
			ctps: params.row.ctps,
			rg: params.row.rg,


		}
		this.dateNasicmento = params.row.born_date;
		this.dateAdmission = params.row.admission;
		this.dados_employees = data;
	},

	updateEmployed(params)
	{
		let id_epregado = this.dados_employees.id;
		let id_empresa = this.dados_companies.id;

		http.put('employees/' + id_epregado, {
			name: this.dados_employees.name,
			cpf: this.dados_employees.cpf,
			office: this.dados_employees.office,
			gender: this.dados_employees.gender,
			pis: this.dados_employees.pis,
			ctps: this.dados_employees.ctps,
			rg: this.dados_employees.rg,
			born_date: this.dateNasicmento,
			admission: this.dateAdmission,
			company_id: this.dados_employees.company_id, 
		})
		.then(response => {
			this.divEditFunc = false;
			this.limpadatas()	
			http.get('companies/'+ id_empresa + '/employees')
			.then(response => {
				this.limpadatas()
				this.employees = response.data;

			})
			.catch(error => {
				this.errors = response;
			});


			swal({
				title: "Funcionário!",
				text: "atualizado com sucesso!",
				icon: "success",
				timer: 1000,
				button: false

			});			
		})
		.catch(error => {
			console.log();
		});
	},

	resetCreatFunc()
	{

		this.funcionario.name = '';
		this.funcionario.cpf = '';
		this.funcionario.gender = '';
		this.funcionario.company_id = '';
		this.funcionario.office = '';
		this.dateNasicmento = '';
		this.dateAdmission = '';
		this.funcionario.rg = '';
		this.funcionario.ctps = '';
		this.funcionario.pis = '';
	},	

	resetCreatComp()
	{
		this.empresa.name = '';
		this.empresa.cnpj = '';
		this.empresa.email = '';
		this.empresa.phone = '';
		this.empresa.ativo = '';
		this.empresa.password_visible = '';
		this.empresa.user_id = '';
	},

	limpadatas()
	{
		this.dateNasicmento = '';
		this.dateAdmission = '';
	},

	fecharModalFuncEmpresa()
	{
		this.modalfuncempresa.dialog = false;
		this.divFunc = false;
		this.divEditFunc = false;
		this.dados_employees = '';
		this.dados_companies = '';
		this.employees = '';
		// this.funcionario = '';
		this.limpadatas()
	},
	fecharModalEditandoEmpresa()
	{
		this.modaleditempresa.dialog = false;
		this.dados_employees = '';
		this.dados_companies = '';
	},

	clickCancelEdit()
	{
		this.divEditFunc = false;
		this.limpadatas()
	}



},
};
</script>
<style type="text/css">
.primary{
	background-color: #007c6f !important;
}
.primary--text{
	color: #007c6f !important;

}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/empresas/Empresas.vue